import * as React from "react"

import { IOptionList } from "shared/hubrise/models"

import Delete from "./Delete"

const Commands = ({ optionList }: { optionList: IOptionList }): JSX.Element => <Delete optionList={optionList} />

export default Commands
